import { render, staticRenderFns } from "./chart-referal-user-registered.vue?vue&type=template&id=7252d564&"
import script from "./chart-referal-user-registered.vue?vue&type=script&lang=js&"
export * from "./chart-referal-user-registered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports